(function (appComponents) {

	appComponents.controllers.mvMotorDetails = function (Components) {
		var mvMotorDetails = {};

		mvMotorDetails.name = "mvMotorDetails";


		Components.getControllerPrototype().extend(mvMotorDetails);

		mvMotorDetails._modals = mvMotorDetails._getService("modals");

		mvMotorDetails.bindings = function () {
			mvMotorDetails._elements.page.on("click", "#pc-download-mv-quote", function () {
				$('.modal').modal("hide");
			});
			$('.download-modal').on('hidden.bs.modal', function (e) {
				$('.download-modal input:checked + .iCheck-helper').click();
			});
		};

		mvMotorDetails.liveBindings = function () {
			$("form[pc-container='mv-product--download-all-form']").off().submit(function () {
				var checkedElements = $(this).find("input[type='checkbox']:checked");
				if (!checkedElements.length) {
					mvMotorDetails._modals.warning.show(mvMotorDetails._messages.noItemsChecked);
					return false;
				}
				$('.download-modal').modal('hide');
			});

			$("[pc-container='mv-motor-details--request-quote-btn']").off().click(function () {
				mvMotorDetails.handlers.onRequestQuote();
			});
		};

		mvMotorDetails.populateInitialContext = function () {
			var mvMotor = mvMotorDetails._stash.mvMotor;
			if (mvMotor == null) return $.Deferred().reject();
			mvMotorDetails.context.product = mvMotor;
			return $.Deferred().resolve();
		};

		mvMotorDetails.generateSuccessReqQuoteMsg = function (code) {
			var url = "/rmstorefront/quote/exportPdf?orderCode=" + code + "&mvMotor=true";
			var html = "Your quote was successfully created, click to <a id='pc-download-mv-quote' href='" + url + "'>download</a>";

			return html;
		};

		mvMotorDetails.handlers = {
			onRequestQuote: function () {
				if (!mvMotorDetails._role.flags.isQuotesAllowed) {
					mvMotorDetails._modals.error.show(mvMotorDetails._messages.noRoleOrB2bRights);
					return;
				}
				var code = mvMotorDetails.context.product.code;
				mvMotorDetails._api.mvMotorDetails.requestQuote(code).then(function (res) {
					if (res && res.status == 200) {
						var html = mvMotorDetails.generateSuccessReqQuoteMsg(res.body);
						mvMotorDetails._modals.success.showHtml(html);
					} else {
						mvMotorDetails._modals.error.show(res.message);
						console.log(res);
					}
				});
			}
		};

		mvMotorDetails.init = function () {

			mvMotorDetails.populateInitialContext().then(function () {

				mvMotorDetails._renderPageTemplate();

				mvMotorDetails._bindings();

				mvMotorDetails._applyScript.base.owl();

				mvMotorDetails._events.dispatchEvent("controllerInitialized");
			}).fail(function (e) {
				console.log(e);
				mvMotorDetails._goToPage("mvmOverview");
			});
		};

		return mvMotorDetails;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});